export const MAIN_TITLE = "Agriculture Research Station Pakhribas (ARSP)";
export const BASE_TITLE = "ARSP | ";
